import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PurchaseHistoryList from 'components/RichProfile/PurchaseHistoryList/PurchaseHistoryList';
import FrameworkUtils from 'utils/framework';
import { showSelector as replenCarouselPurchaseHistoryShowSelector } from 'selectors/testTarget/offers/replenCarouselPurchaseHistory/show/showSelector';

const { wrapHOC } = FrameworkUtils;

const fields = createStructuredSelector({
    isReplenCarouselOfferEnabled: replenCarouselPurchaseHistoryShowSelector
});

const withPurchaseHistoryListProps = wrapHOC(connect(fields, null));

export default withPurchaseHistoryListProps(PurchaseHistoryList);
